"use strict";

var cov_23wrwe8bqs = function () {
  var path = "/Volumes/GithubWorkspace/gitea-react-toolkit/src/components/application-bar/helpers.js";
  var hash = "7e1269ca887b3da994811f3e32cc12006fc19360";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/Volumes/GithubWorkspace/gitea-react-toolkit/src/components/application-bar/helpers.js",
    statementMap: {
      "0": {
        start: {
          line: 1,
          column: 29
        },
        end: {
          line: 6,
          column: 1
        }
      },
      "1": {
        start: {
          line: 2,
          column: 2
        },
        end: {
          line: 2,
          column: 30
        }
      },
      "2": {
        start: {
          line: 2,
          column: 18
        },
        end: {
          line: 2,
          column: 30
        }
      },
      "3": {
        start: {
          line: 3,
          column: 16
        },
        end: {
          line: 3,
          column: 45
        }
      },
      "4": {
        start: {
          line: 4,
          column: 12
        },
        end: {
          line: 4,
          column: 57
        }
      },
      "5": {
        start: {
          line: 5,
          column: 2
        },
        end: {
          line: 5,
          column: 70
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 1,
            column: 29
          },
          end: {
            line: 1,
            column: 30
          }
        },
        loc: {
          start: {
            line: 1,
            column: 41
          },
          end: {
            line: 6,
            column: 1
          }
        },
        line: 1
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 1,
            column: 30
          },
          end: {
            line: 1,
            column: 36
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 1,
            column: 35
          },
          end: {
            line: 1,
            column: 36
          }
        }],
        line: 1
      },
      "1": {
        loc: {
          start: {
            line: 2,
            column: 2
          },
          end: {
            line: 2,
            column: 30
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 2,
            column: 2
          },
          end: {
            line: 2,
            column: 30
          }
        }, {
          start: {
            line: 2,
            column: 2
          },
          end: {
            line: 2,
            column: 30
          }
        }],
        line: 2
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0
    },
    f: {
      "0": 0
    },
    b: {
      "0": [0],
      "1": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184",
    hash: "7e1269ca887b3da994811f3e32cc12006fc19360"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  return coverage[path] = coverageData;
}();

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.humanFileSize = void 0;
cov_23wrwe8bqs.s[0]++;

var humanFileSize = function humanFileSize() {
  var size = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (cov_23wrwe8bqs.b[0][0]++, 0);
  cov_23wrwe8bqs.f[0]++;
  cov_23wrwe8bqs.s[1]++;

  if (size === 0) {
    cov_23wrwe8bqs.b[1][0]++;
    cov_23wrwe8bqs.s[2]++;
    return '0 B';
  } else {
    cov_23wrwe8bqs.b[1][1]++;
  }

  var units = (cov_23wrwe8bqs.s[3]++, ['B', 'KB', 'MB', 'GB', 'TB']);
  var i = (cov_23wrwe8bqs.s[4]++, Math.floor(Math.log(size) / Math.log(1024)));
  cov_23wrwe8bqs.s[5]++;
  return (size / Math.pow(1024, i)).toFixed(2) * 1 + ' ' + units[i];
};

exports.humanFileSize = humanFileSize;